import Channel from "./assets/icons/Channel";
import Courses from "./assets/icons/Courses";
import Fashion from "./assets/icons/Fashion";
import Gaming from "./assets/icons/Gaming";
import History from "./assets/icons/History";
import Home from "./assets/icons/Home";
import Like from "./assets/icons/Like";
import Live from "./assets/icons/Live";
import Movies from "./assets/icons/Movies";
import Music from "./assets/icons/Music";
import News from "./assets/icons/News";
import Playlist from "./assets/icons/Playlist";
import Podcasts from "./assets/icons/Podcasts";
import Shopping from "./assets/icons/Shopping";
import Shorts from "./assets/icons/Shorts";
import Sports from "./assets/icons/Sports";
import Subscriptions from "./assets/icons/Subscriptions";
import Trending from "./assets/icons/Trending";
import Videos from "./assets/icons/Videos";
import WatchLater from "./assets/icons/WatchLater";

export const sidebarBasic = [
  {
    icon: <Home />,
    title: "Home",
    url: "/",
  },
  {
    icon: <Shorts />,
    title: "Shorts",
    // url: "/v=shorts",
    url: "/",
  },
  {
    icon: <Subscriptions />,
    title: "Subscriptions",
    // url: "/v=subscriptions",
    url: "/",
  },
];

export const sidebarYou = [
  {
    icon: <Channel />,
    title: "Your Channel",
  },
  {
    icon: <History />,
    title: "History",
  },
  {
    icon: <Playlist />,
    title: "Playlists",
  },
  {
    icon: <Videos />,
    title: "Your videos",
  },
  {
    icon: <WatchLater />,
    title: "Watch Later",
  },
  {
    icon: <Like />,
    title: "Liked videos",
  },
];

export const subscriptionList = [
  {
    avatar:
      "https://yt3.googleusercontent.com/ytc/AIdro_md2CfeGP7cDguRmrpRdM3a1r_gOniMzennD6141VLFw70=s900-c-k-c0x00ffffff-no-rj",
    name: "Akshay Saini",
  },
  {
    avatar:
      "https://yt3.ggpht.com/ytc/AIdro_l_j492nkzqD1_nA9DqHl-r4L5pe9AI_jzhy9BX-af45JI=s88-c-k-c0x00ffffff-no-rj",
    name: "Tharun Speaks",
  },
  {
    avatar:
      "https://yt3.ggpht.com/ytc/AIdro_lGRc-05M2OoE1ejQdxeFhyP7OkJg9h4Y-7CK_5je3QqFI=s88-c-k-c0x00ffffff-no-rj",
    name: "freecodecamp",
  },
  {
    avatar:
      "https://yt3.ggpht.com/VLOvpKYxd_ZTrjrorHo5VkqaO0lM1Zs2Zbe-Nrfx7UkWnUGKNbpgEcDxhSjDWS4UONdtyKddLQ=s88-c-k-c0x00ffffff-no-rj",
    name: "Hitesh Choudhary",
  },
  {
    avatar:
      "https://yt3.ggpht.com/ytc/AIdro_k2O-2O1fL6S58poofnawszoBfzsl1YBpciM9BDhupgLToC=s88-c-k-c0x00ffffff-no-rj",
    name: "Nishant Chahar",
  },
  {
    avatar:
      "https://yt3.ggpht.com/Xxr9GvsePwYQ3b8LYaPjTmSxtbQIHzjG2X-Z_VqzSxD9lPhAByovkFCrAguwViYM9PyXuFAV=s88-c-k-c0x00ffffff-no-rj",
    name: "Sasha Alex Sloan",
  },
  {
    avatar:
      "https://yt3.ggpht.com/ytc/AIdro_mKzklyPPhghBJQH5H3HpZ108YcE618DBRLAvRUD1AjKNw=s88-c-k-c0x00ffffff-no-rj",
    name: "Fireship",
  },
];

export const explore = [
  {
    icon: <Music />,
    id: "10",
    title: "Music",
    url: "/?v=10",
  },
  {
    icon: <Gaming />,
    id: "20",
    title: "Gaming",
    url: "/?v=20",
  },
  {
    icon: <News />,
    id: "25",
    title: "News",
    url: "/?v=25",
  },
  {
    icon: <Sports />,
    id: "17",
    title: "Sports",
    url: "/?v=17",
  },
  {
    icon: <Courses />,
    id: "28",
    title: "Technology",
    url: "/?v=28",
  },
  {
    icon: <Fashion />,
    id: "26",
    title: "Fashion & Beauty",
    url: "/?v=26",
  },
  {
    icon: <Podcasts />,
    id: "22",
    title: "Blogs",
    url: "/?v=22",
  },
  {
    icon: <Live />,
    title: "Live",
    url: "/?v=live",
  },
];
